import React, { useLayoutEffect, useRef, useEffect, useState} from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { Link } from "react-router-dom";
import { BaseUrl } from "../../helper/BaseUrl";
import axios from "axios";

export default function HomeProject({ initialProjects = [] }) {
  const containerRef = useRef(null);
  const [allData, setAllData] = useState(initialProjects);

  useEffect(() => {
      if (initialProjects.length > 0) {
          return;
      }

      const dataFetcher = async () => {
          try {
          const response = await axios.get(`${BaseUrl}/api/project`);
          setAllData(response.data.data || []); 
          } catch (error) {
          console.error("Data fetch error:", error);
          }
    };

    dataFetcher();
    }, [initialProjects.length]);

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const ctx = gsap.context(() => {
      const images = gsap.utils.toArray(".hp-left-content img");
      const rightElements = gsap.utils.toArray(".hp-right-content .hp-right-element");

      if (!images.length || !rightElements.length) return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top top",
          end: `+=${100 * Math.max(images.length, rightElements.length)}%`,
          pin: true,
          scrub: true,
          // markers: true,
        },
      });

      images.forEach((img, i) => {
        if (images[i + 1]) {
          tl.to(img, { opacity: 0 })
            .to(images[i + 1], { opacity: 1 }, "<")
            .to(
              rightElements,
              { yPercent: -(100 * (i + 1)), ease: "none" },
              "<"
            );
        }
      });

      // tl.to({}, {}, "+=0.5");
    }, containerRef);

    return () => ctx.revert();
  }, [allData]);


  return (
    <>
      <div className="hp-container" ref={containerRef}>
        <div className="hp-left-container">
          <div className="hp-left-content">

            {allData && allData.slice(0,3).map((data,index)=>( 
            <img src={`${BaseUrl}${data.home_project_image}`} loading="lazy" className="img-responsive" alt="project" key={index}/>
            ))}
          </div>
        </div>

        <div className="hp-right-container">
          <div className="hp-right-content"> 

            {allData && allData.slice(0,3).map((data,index)=>( 
            <div className="hp-right-element" key={index}>
                <Link to={`/project/${data.slug}`}>
                    <img src={`${BaseUrl}${data.home_project_image}`} loading="lazy" className="img-responsive" alt="project"/>
                    <p>{data.title}</p>
                </Link>
            </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
